import React, { useEffect, useState } from 'react';
import { formatPoints } from '../../../utils/helper';
import { customerData, getVouchersList, myRewardsToken } from '../../auth/auth';
import Loader from '../../partial/Loader';
import { getFirstSentence } from '../../../utils';
import RedeemRewardModal from '../homepage/RedeemRewardModal';
import { Link } from 'react-router-dom';
import PointsFilter from './PointsFilter ';

const RewardsContent = ({ updateFormData, setActiveSection }) => {
	const [loader, setLoader] = useState(true);
	const [selectedReward, setSelectedReward] = useState(null);
	const [response, setResponse] = useState([]);
	const [data, setData] = useState([])
	const [showPopup, setShowPopup] = useState(false);
	const [popupReward, setPopupReward] = useState(null);
	const [showFilterModal, setShowFilterModal] = useState(false)
	const [walletsDetail, setWalletsDetail] = useState();
	const [selectedPoints, setSelectedPoints] = useState([]);
	const token = JSON.parse(localStorage.getItem('token_gen'));
	const customerid = localStorage.getItem("customerid");

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoader(true);
				const customerCode = localStorage.getItem("customercode");
				const [voucherRes, customerRes] = await Promise.all([
					getVouchersList(token?.access_token),
					customerData(token?.access_token, customerCode, 1, 5),
				]);
				const activeVoucher = voucherRes?.data
					?.filter((ele) => ele.isActive)
					?.sort((a, b) => Number(a.voucherValue) - Number(b.voucherValue));

				setData(activeVoucher);
				setResponse(activeVoucher);
				setWalletsDetail(customerRes?.walletsDetail);

			} catch (err) {
				console.error(err);
			} finally {
				setLoader(false);
			}
		};

		fetchData();
	}, []);

	const handleSelect = (reward) => {
		const formattedData = {
			Name: reward.name,
			totalpoint: Number(reward.voucherValue) * 100,
		};

		setSelectedReward(reward);
		updateFormData(formattedData);
		setActiveSection('achievement_timeline');
	};

	const handlePopup = (reward) => {
		setPopupReward(reward);
		setShowPopup(true);
	};

	return (
		<>
			<div
				className='timeline-content-inner active'
				id='select_reward'>
				{loader && <Loader />}

				<div
					className='timeline-rewards mb-2'>
					{/* <h4>{category.category}</h4> */}
					<div className='timeline-rewards-headerbig'>
						<div className='timeline-rewards-headerbig-left'>
							<h4>Rewards</h4>
						</div>
						<div className='timeline-rewards-headerbig-right'>
							<Link to='' onClick={() => setShowFilterModal(true)}><img src='https://cdn-icons-png.flaticon.com/512/107/107799.png' />Filters</Link>
						</div>
					</div>
					{!loader && data?.length === 0 && (
						<div>No rewards available</div>
					)}
					{data?.map((reward, index) => {
						const firstLine = getFirstSentence(reward?.description || "");
						return (
							<div className='timeline-rewards mb-2' key={index}>
								<div className='timeline-rewards-grid'>
									<div
										key={index}
										className={`timeline-rewards-box ${selectedReward?.id === reward.id
											? 'border-2 border-blue-500'
											: ''
											}`}>
										<div className='timeline-rewards-box-image' style={{ cursor: "pointer" }} onClick={() =>
											handlePopup(reward)
										}>
											{customerid !== "13217511" &&
												(walletsDetail?.availableValue < (parseInt(reward?.voucherValue))) && (
													<div className="overlay_lock">
														<span className="lock_icon">
															<i class="fa-solid fa-lock"></i>
														</span>
													</div>)
											}
											{customerid !== "13217511" && <span className={walletsDetail?.availableValue >= (parseInt(reward?.voucherValue * 100)) ? "unlocked-badge" : "locked-badge"}>
												{walletsDetail?.availableValue >= parseInt(reward.voucherValue * 100) ? "Unlocked" : <img src='https://cdn-icons-png.flaticon.com/512/115/115681.png' />}
											</span>}
											<img
												src={reward.imageUpload}
												alt={reward.name}
											// onClick={() => handleSelect(reward)}
											/>
										</div>

										<div className='timeline-rewards-box-content'>
											<h5 style={{ cursor: "pointer" }} onClick={() =>
												handlePopup(reward)
											}>{reward.name}</h5>
											<span className='points'>
												{formatPoints(reward.voucherValue * 100)} Points
												{/* (₹{formatPoints(reward.voucherValue / 100)}) */}
											</span>

											{firstLine ? (
												<span
													style={{
														display: 'block',
														marginTop: '0.125rem',
														marginBottom: '0.5rem',
														padding: 0,
														fontSize: '0.875rem',
														color: '#4b5563',
														lineHeight: '1.4',
														fontWeight: 400,
														whiteSpace: 'normal',
														overflow: 'visible',
														textOverflow: 'clip',
													}}>
													{firstLine}
												</span>
											) : (
												<></>
											)}

											<div className='timeline-rewards-box-content-inner'>
												<div className='timeline-rewards-box-content-inner-left'>
													<button
														onClick={() =>
															handlePopup(reward)
														}
														className='text-blue-500 large_btn'>
														View details
													</button>
												</div>
												{customerid !== "13217511" && walletsDetail?.availableValue >= parseInt(reward?.voucherValue * 100) && <div className='timeline-rewards-box-content-inner-right'>
													<button
														onClick={() => handlePopup({
															...reward,
															availablePoints: walletsDetail?.availableValue,
															isUnlocked: walletsDetail?.availableValue >= parseInt(reward.voucherValue * 100),
														})}
														className='redeem-now-btn'>
														Redeem Now
													</button>
												</div>}

												{customerid === "13217511" && (
													<div className='timeline-rewards-box-content-inner-right'>
														<button
															className={`btn ${selectedReward?.id ===
																reward.id
																? 'bg-blue-500 text-white'
																: ''
																}`}
															onClick={(e) => {
																e.stopPropagation();
																handleSelect(reward);
															}}>
															<span>
																{selectedReward?.id ===
																	reward.id
																	? 'Selected'
																	: 'Select'}
															</span>
														</button>
													</div>)}
											</div>
										</div>
									</div>
								</div>

							</div>
						);
					})}
				</div>
				<RedeemRewardModal
					showPopup={showPopup}
					setShowPopup={setShowPopup}
					setPopupReward={setPopupReward}
					popupReward={popupReward}
					setLoader={setLoader}
					handleSelect={handleSelect}
				/>
			</div>

			{showFilterModal && <PointsFilter
				setShowFilterModal={setShowFilterModal}
				setData={setData}
				response={response}
				selectedPoints={selectedPoints}
				setSelectedPoints={setSelectedPoints}
			/>}
		</>

	);
};

export default RewardsContent;
